<template>
	<section id="contact">
		<div class="col-12 my-5">

			<div class="col-12 col-md-8 offset-md-2">
				<h1 class="text-center">GET IN TOUCH</h1>
				<h3 class="text-center mb-5">We'd love to hear from you!</h3>

				<form class="form contact-form overview-card p-3" @submit="onSubmit">
					<div class="row my-5">
						<div class="col-6">
							<input required v-model="form.name" min="2" placeholder="Name" class="form-control">
						</div>
						<div class="col-6">
							<input required v-model="form.email" type="email" placeholder="Email" class="form-control">
						</div>
					</div>
					<div class="row my-5">
						<div class="col-12">
							<input required v-model="form.subject" placeholder="Subject" class="form-control">
						</div>
					</div>
					<div class="row my-5">
						<div class="col-12">
							<textarea required placeholder="Message" v-model="form.message" class="form-control"></textarea>
						</div>
					</div>

					<div class="row my-5 text-center">
						<div class="col-6 offset-3">
							<button class="btn btn-secondary btn-block" :disabled="loading">Send</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios'

export default {
	name: "ContactSection",
	data() {
		return {
			loading: false,
			form: {
				name: "",
				email: "",
				subject: "",
				message: "Message"
			}
		}
	},
	methods: {
		onSubmit(e) {
			e.preventDefault();
			this.discordPost();
		},

		formContent() {
			return `New Contact Form Submission!\nName: ${this.form.name}\nEmail: ${this.form.email}\nSubject: ${this.form.subject}\nMessage: ${this.form.message}`;
		},

		reset() {
			this.loading = false;
			this.form = {
				name: "",
				email: "",
				subject: "",
				message: ""
			}
		},

		discordPost() {
			this.loading = true
			axios.post('https://discord.com/api/webhooks/955546992967319572/eKiJYcSe6C6785WFtmJCp111QMeUJ1uoPDMHW_zFhwl6F6b9KoB1j0y705GCiB_FWWSI', {
				content: this.formContent()
			}).then(response => {
				console.log(response);
				this.reset();
				this.$toastr.s("Form submitted successfully!");
			}).catch(error => {
				console.log(error);
				this.loading = false;
				this.$toastr.e("Unable to send form")
			});

		}
	}
}
</script>

<style scoped>

</style>